// extracted by mini-css-extract-plugin
module.exports = {"ViewerTabs":"Ik58f1ZvEErIUS2iswOE7w=="};